// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLogoPage-BackLink_cls1__V9OU+","cls2":"VeloLogoPage-BackLink_cls2__OFCni VeloLogoPage-BackLink_cls1__V9OU+"};